
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 199 196","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill-rule":"nonzero"}},[_c('path',{attrs:{"d":"M122.289 142.622H40.622c-4.105 0-7.434 4.78-7.434 8.886 0 4.107 3.329 8.888 7.434 8.888h81.667c4.107 0 7.435-4.781 7.435-8.888 0-4.105-3.328-8.886-7.435-8.886zM50.28 127.781h20.176c9.243-.011 16.733-7.502 16.746-16.746V55.314c-.01-9.245-7.502-16.736-16.746-16.746H50.28c-9.244.01-16.735 7.501-16.746 16.746v55.72c.01 9.245 7.502 16.737 16.746 16.747zm-.425-71.015a1.903 1.903 0 011.878-1.878h17.27a1.903 1.903 0 011.877 1.878v52.816a1.903 1.903 0 01-1.876 1.878H51.733a1.903 1.903 0 01-1.878-1.878V56.766zm72.434 40.347h-19.531c-4.105 0-7.435 4.782-7.435 8.888 0 4.105 3.33 8.887 7.435 8.887h19.53c4.108 0 7.436-4.782 7.436-8.887 0-4.106-3.328-8.888-7.435-8.888zm0-42.05h-19.531c-4.105 0-7.435 4.78-7.435 8.886 0 4.107 3.33 8.888 7.435 8.888h19.53c4.108 0 7.436-4.78 7.436-8.888 0-4.105-3.328-8.886-7.435-8.886z"}}),_c('path',{attrs:{"d":"M190.785 59.012H161V24.494C161 10.99 149.485 0 135.314 0H25.87C11.707 0 .197 10.99.197 24.494V171.36c0 13.505 11.51 24.494 25.672 24.494H171.19v.012c.17 0 .339-.008.506-.02.16.004.319.007.479.008 14.376-.016 26.028-11.666 26.044-26.044V66.447a7.434 7.434 0 00-7.434-7.435zM20.963 175.072c-1.938-1.81-3.004-4.16-3.004-6.618V27.41c0-2.457 1.066-4.807 3.004-6.616a11.368 11.368 0 017.81-3.021h103.638a11.388 11.388 0 017.812 3.006c1.935 1.81 3.004 4.161 3.004 6.617v139.509a25.976 25.976 0 002.53 11.186H28.773a11.362 11.362 0 01-7.81-3.02zm159.483-8.167c0 6.099-3.433 11.056-9.504 11.173-6.266.12-9.942-5.127-9.942-11.394V76.785h19.446v90.12z"}})])])
          )
        }
      }
    